$(document).ready(function(){
    // Video Section Play Button Start
    $('deferred-media div[data-media-wrapper].external-media-ratio--original video').each(function () {
        const video = this;
        const playButton = $(video).closest('[data-media-wrapper]').find('.play-button');

        $(video).on('play', function () {
            playButton.addClass('hidden');
        });

        $(video).on('pause ended', function () {
            playButton.removeClass('hidden');
        });
    });
    // Video Section Play Button End

    // Social Proof Start
    $('.social-proof').each(function () {
        const section = $(this);

        new Swiper(section.find('.social-proof-slider')[0], {
            slidesPerView: 1,
            loop: true,
            // autoHeight: true,
            speed: 800,
            autoplay: section.data('autoplay')
            ? {
                delay: section.data('speed'),
                disableOnInteraction: false,
                }
            : false,

            pagination: {
                el: section.find('.swiper-pagination')[0],
                clickable: true,
            },
        });
    });
    // Social Proof Start

   // Store original button text on page load
    $('[data-quick-add-button]').each(function () {

        const button = $(this);

        if (!button.attr('data-original-text')) {
            button.attr(
                'data-original-text',
                button.text().trim()
            );
        }

    });

    // Product Card AddToCart Start
    $(document).on('submit', 'form[action*="/cart/add"]', function () {

        const form = $(this);
        const button = form.find('[data-quick-add-button]');

        if (!button.length) return;

        const originalText = button.attr('data-original-text');

        let thankYouShown = false;

        // Wait for Flow loading state
        const waitForLoading = setInterval(function () {

            if (button.hasClass('is-loading')) {

                clearInterval(waitForLoading);

                // Remove spinner
                button.find('svg').remove();

                // Show Adding...
                button.html('Adding...');

                // Wait for loading finish
                const waitForFinish = setInterval(function () {

                    button.find('svg').remove();

                    if (!button.hasClass('is-loading') && !thankYouShown) {

                        thankYouShown = true;

                        clearInterval(waitForFinish);

                        // Show Thank You!
                        button.html('Thank You!');

                        // Restore original text after 3 sec
                        setTimeout(function () {

                            button
                                .removeClass('is-loading')
                                .html(originalText);

                        }, 3000);
                    }

                }, 10);
            }

        }, 10);

    });
    // Product Card AddToCart End

    // Product Card Mobile Slider Start
    function initMobileOnlySlider() {
        $('.mobile-only-slider').each(function () {
            const slider = $(this);

            if ($(window).width() < 768) {
                if (!this.swiper) {
                    new Swiper(this, {
                        slidesPerView: Number(slider.data('slides-per-view')),
                        spaceBetween: Number(slider.data('space-between')),
                        pagination: {
                            el: slider.find('.mobile-slider-pagination')[0],
                            clickable: true
                        },
                        navigation: {
                            prevEl: slider.find('.mobile-slider-prev')[0],
                            nextEl: slider.find('.mobile-slider-next')[0]
                        }
                    });
                }
            } else {
                if (this.swiper) {
                    this.swiper.destroy(true, true);
                }
            }
        });
    }

    initMobileOnlySlider();

    $(window).on('resize', function () {
        initMobileOnlySlider();
    });
    //Product Card Mobile Slider End

    // Product Thumbnail Start
    $(function () {
        const thumbnailContainer = $('[data-media-thumbnails]');
        if (!thumbnailContainer.length) return;

        const thumbnailSwiper = thumbnailContainer[0]?.swiper;
        if (!thumbnailSwiper) return;

        thumbnailSwiper.destroy(false, false);

        thumbnailContainer.removeClass('swiper swiper-initialized swiper-vertical swiper-horizontal swiper-backface-hidden').addClass('custom-thumbnail-gallery');

        thumbnailContainer.find('.swiper-wrapper').css({
            transform: 'none',
            transition: 'none',
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
            height: 'auto'
        });

        thumbnailContainer.find('.swiper-slide').css({
            width: '100%',
            height: 'auto',
            margin: 0
        });

        thumbnailContainer.on('click', '.swiper-slide', function () {
            const thumbnail = $(this);
            const index = thumbnail.index();

            const mainSwiper = $('[data-slider-main]')[0]?.swiper;

            if (!mainSwiper) {
                return;
            }

            mainSwiper.slideTo(index);

            thumbnail
                .addClass('is-active')
                .siblings()
                .removeClass('is-active');
        });
    });
    // Product Thumbnail End

    // Blog Post Slider Start
    const blogPostSlider = new Swiper('.template-blog__grid', {
        autoHeight: false,
        navigation: {
            nextEl: ".template-blog-post .swiper-button-next",
            prevEl: ".template-blog-post .swiper-button-prev",
        },
        loop: true,
        breakpoints: {
            565: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 2,
            },
            990: {
                slidesPerView: 3,
            },
            1224: {
                slidesPerView: 4,
            },
        }
    })
    // Blog Post Slider End
})
